export default __webpack_public_path__ + "static/screen-3a6924fa21fcc97786b7516066c44374.png";